<template>
  <div class="form-group">
    <label class="font-weight-bold" for="id_cidades_atuacao">
      {{ label }}
    </label>
    <b-row class="align-items-center">
      <b-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        class="d-flex align-items-center mb-2 mr-2"
        v-for="(selectedSegments, index) in selects"
        :key="index"
      >
        <v-select
          label="nome"
          :placeholder="placeholder"
          :options="segmentos"
          :reduce="(segment) => segment.id"
          @input="onSelect($event, index)"
        >
          <div slot="no-options">
            {{ noOptionsText }}
          </div>
        </v-select>
        <b-button
          v-if="isOptional || (!isOptional && index !== 0)"
          class="delete-segment d-flex justify-content-center"
          variant="danger"
          @click="removeSelect(index)"
        >
          <i class="fas fa-times"></i>
        </b-button>
      </b-col>
    </b-row>
    <p v-if="errorMessage !== null" class="error-message text-danger">
      {{ errorMessage }}
    </p>
    <b-row>
      <b-col cols="12">
        <b-button pill variant="success" class="mt-1" @click="addSelect()">
          <i class="fas fa-plus mr-2"></i>
          {{ addButtonText }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';

export default {
  name: 'SelectSegments',
  mixins: [makeToast],
  props: {
    label: {
      type: String,
      required: true,
    },
    selectedSegments: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Selecione o(s) segmento(s)',
    },
    noOptionsText: {
      type: String,
      default: 'Segmento não encontrado',
    },
    addButtonText: {
      type: String,
      default: 'Adicionar Segmento',
    },
    isOptional: {
      type: Boolean,
      default: true,
    },
    errorMessage: {},
  },
  watch: {
    selectedSegments() {
      this.selectedSegmentsId = this.selectedSegments;
    },
  },
  computed: {
    ...mapState(['segmentos']),
  },
  data() {
    return {
      selects: [],
      selectedSegmentsId: [],
    };
  },
  created() {
    if (!this.isOptional && this.selectedSegments.length === 0) {
      this.selects.push(null);
    }
  },
  methods: {
    onSelect(selectedSegment, index) {
      this.$emit('update:errorMessage', null);

      if (!selectedSegment) {
        this.removeSegment(index);
        return;
      }
      if (!this.selectedSegmentsId.some((s) => s === selectedSegment)) {
        this.selectedSegmentsId[index] = selectedSegment;
        this.$emit('update:selectedSegments', this.selectedSegmentsId);
      }
    },
    addSelect() {
      this.selects.push(null);
    },
    removeSelect(index) {
      this.selects.splice(index, 1);
      this.selectedSegmentsId.splice(index, 1);
      this.$emit('update:selectedSegments', this.selectedSegmentsId);
    },
    removeSegment(index) {
      this.selectedSegmentsId[index] = null;
      this.$emit('update:selectedSegments', this.selectedSegmentsId);
    },
  },
};
</script>

<style scoped>
.delete-segment {
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
</style>
